import {
  CellFormatOptions,
  ColumnTable,
  TableCollapsable,
} from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../../../locales/translations';
import { StudentWarningsObservationDetailsGroupType } from '../types';
import StudentInformationGroup from './StudentInformationGroup';
import StudentObservationGroup from './StudentObservationGroup';

const StudentWarningsObservationTable = () => {
  const { t } = useTranslation(
    TranslationsKeys.STUDENT_WARNINGS_STUDENT_OBSERVATIONS,
  );
  const COLUMNS: ColumnTable<any>[] = [
    {
      headerText: t('table.columns.concept'),
      columnName: 'concept',
      thClassName: 'text-left pl-5',
      tdClassName: 'pl-5',
    },
  ];

  const DATA_COMPONENTS = [
    {
      concept: t(
        `${StudentWarningsObservationDetailsGroupType.StudentFile}.title`,
      ),
      type: StudentWarningsObservationDetailsGroupType.StudentFile,
      component: <StudentInformationGroup />,
    },
    {
      concept: t(
        `${StudentWarningsObservationDetailsGroupType.Observation}.title`,
      ),
      type: StudentWarningsObservationDetailsGroupType.Observation,
      component: <StudentObservationGroup />,
    },
  ];

  return (
    <div className="w-100 d-flex flex-column mt-3" style={{ gap: 12 }}>
      <TableCollapsable<any>
        isLoading={false}
        data={DATA_COMPONENTS}
        isCollapsable={(row) => {
          return true;
        }}
        columns={COLUMNS}
        secondColumn={{
          columnName: 'second',
          headerText: 'second',
          cellFormat: ({ row }: CellFormatOptions<any>) => row.component,
        }}
        color="default"
      />
    </div>
  );
};

export default StudentWarningsObservationTable;
